import { sidebarToggledEvent } from '#pplx/frontend/apps/ask/events/sidebar/analytics.js';
import { EVENT_PAYLOAD } from '#pplx/frontend/framework/instrumentation/types.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { useCallback } from 'react';
const sidebarWidthChangedEvent = EVENT_PAYLOAD;
export function useSidebarResizeAnalytics() {
    const { track } = useInstrumentation();
    const onWidthCommitted = useCallback((widthPx, source) => track(sidebarWidthChangedEvent({ name: 'sidebar width changed', data: { widthPx, source } })), [track]);
    const onPinnedCommitted = useCallback((pinned) => track(sidebarToggledEvent({ name: 'sidebar toggled', data: { is_collapsed: !pinned } })), [track]);
    return { onWidthCommitted, onPinnedCommitted };
}
//# sourceMappingURL=useSidebarResizeAnalytics.js.map